// extracted by mini-css-extract-plugin
module.exports = {"placementModifierItem":"PH0rd","placementModifierItem-active":"_9h5kR"};